module.exports = __webpack_public_path__ + "media/mypage/images/icons/arrow_right_b-1ca2bdf63e478b8ea0fb76fe689842e6.svg";